export const UNASSIGNED_INVOICE_BRANCH_KEY = '__unassigned_invoice_branch__'

export type InvoiceBranchLookup = Record<string, { displayName?: string | null }>

type AppointmentBranchRef = {
    id: string
    branchId?: string | null
}

export const normalizeInvoiceBranchKey = (branchId?: string | null): string =>
    branchId ?? UNASSIGNED_INVOICE_BRANCH_KEY

export const getSelectedInvoiceBranchKey = (
    selectedAppointmentIds: string[],
    appointments: AppointmentBranchRef[],
): string | undefined => {
    for (const appointmentId of selectedAppointmentIds) {
        const appointment = appointments.find(candidate => candidate.id === appointmentId)
        if (appointment) {
            return normalizeInvoiceBranchKey(appointment.branchId)
        }
    }

    return undefined
}

export const canSelectInvoiceAppointmentBranch = (
    selectedBranchKey: string | undefined,
    branchId?: string | null,
): boolean =>
    !selectedBranchKey || selectedBranchKey === normalizeInvoiceBranchKey(branchId)

export const getInvoiceBranchFilterOptionLabel = (
    branchId: string,
    displayName?: string | null,
): string => {
    const trimmedDisplayName = displayName?.trim()
    if (!trimmedDisplayName || trimmedDisplayName === branchId) {
        return branchId
    }

    return `${trimmedDisplayName} (${branchId})`
}

export const getInvoiceBranchFilterOptions = (
    branches?: InvoiceBranchLookup,
): Array<{ id: string; label: string }> =>
    Object.entries(branches ?? {}).map(([branchId, branch]) => ({
        id: branchId,
        label: getInvoiceBranchFilterOptionLabel(branchId, branch?.displayName),
    }))

export const resolveInvoiceBranchFilterId = (
    label: string,
    branches?: InvoiceBranchLookup,
): string | undefined =>
    getInvoiceBranchFilterOptions(branches).find(option => option.label === label)?.id
